export default __webpack_public_path__ + "static/media/Divide-Icon.453aaec1.svg";